const currentLocation = window.location.origin + window.location.pathname;

const onContentLoad = function () {
	let passwordSectionEl = document.getElementById('shopify-section-password-overlay');

	let btn = document.getElementById('password-submit');
	let input = document.getElementById('password-input');

	const megaNavLinks = document.querySelectorAll('.menu-desktop__link, .menu-extras__search__button, .menu-extras__currency__button, .menu-extras__cart, .footer-links, .header-main__toggle button');

	let accountDropdown = document.querySelector('.header-main .menu-extras__user__dropdown');

	document.body.classList.add('no-overflow');

	if (!passwordSectionEl) return;

	if (document.cookie.indexOf('vip_password') != -1) {
		let passwordCookieValue = document.cookie.split('vip_password=').pop().split(';')[0];
		if (passwordCookieValue == window.passwordValue) {
			if (megaNavLinks) for (const link of megaNavLinks) link.style.display = 'block';
			passwordSectionEl.classList.add('hidden');
			document.body.classList.remove('no-overflow');
			return;
		} else {
			if (accountDropdown) {
				accountDropdown.style.left = 'auto';
				accountDropdown.style.right = '-32px';
			}
		}
	} else {
		if (accountDropdown) {
			accountDropdown.style.left = 'auto';
			accountDropdown.style.right = '-32px';
		}
	}

	if (btn) {
		btn.addEventListener('click', function (e) {
			if (input && input.value != window.passwordValue) {
				document.getElementById('error-message').style.display = 'block';
				e.preventDefault();
			} else {
				let expires = new Date();
				expires.setTime(expires.getTime() + 30 * 24 * 60 * 60 * 1000);
				document.cookie = 'vip_password=' + window.passwordValue + ';expires=' + expires.toUTCString() + ';path=/';

				passwordSectionEl.classList.add('hidden');
				document.body.classList.remove('no-overflow');
				const styleTag = document.getElementById('password-styles');
				if (styleTag) styleTag.remove();
			}
		});
	}

	if (excludedPages.length > 0) {
		for (let i = 0; i < excludedPages.length; i++) {
			if (excludedPages[i] === currentLocation) {
				document.querySelector('.password-overlay').classList.add('hidden');
				document.body.classList.remove('no-overflow');
			}
		}
	}
};
window.addEventListener('DOMContentLoaded', onContentLoad);

const toggleText = document.querySelectorAll('.text-reveal');

if (toggleText) {
	for (const toggle of toggleText) {
		toggle.classList.add('initialiazed');
		toggle.addEventListener('click', function (e) {
			const parent = toggle.parentNode;
			const passwordInput = parent.querySelector('input');
			e.preventDefault();
			toggle.classList.toggle('toggled');
			const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
			passwordInput.setAttribute('type', type);
		});
	}
}
